/* ------------------------------------------------------------------ */
/*  Constantes de configuración para Conversaciones Globales           */
/* ------------------------------------------------------------------ */

const CONVERSACIONES_META = {
  1: {
    foco: "Fortaleza",
    color: "#534AB7",
    colorClaro: "#F0EDFF",
    icono: "mdi:cog-outline",
  },
  2: {
    foco: "Conexión rápida",
    color: "#993C1D",
    colorClaro: "#FFF0EA",
    icono: "mdi:phone-outline",
  },
  3: {
    foco: "Aprendizaje",
    color: "#3B6D11",
    colorClaro: "#EDF7E3",
    icono: "mdi:target",
  },
  4: {
    foco: "Rol en grupo",
    color: "#185FA5",
    colorClaro: "#E3F0FB",
    icono: "mdi:chart-line",
  },
  5: {
    foco: "Liderazgo",
    color: "#BA7517",
    colorClaro: "#FFF6E8",
    icono: "mdi:magnify",
  },
};

export default CONVERSACIONES_META;
